import { Component, OnInit } from '@angular/core';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
// import { UploadOutput, UploadFile, humanizeBytes, UploaderOptions } from 'ngx-uploader';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
declare var $;

const filesize = require('filesize');

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
})
export class HelpComponent implements OnInit {
  dragOver: boolean;
  filelength;
  errorMsg = false;
  invalidFileMsg = false;
  url = environment.api_url;
  uploadedFilename = [];

  showHelp;
  userObj = {
    fullName: '',
    emailId: '',
    helpQues: '',
    type: 'help',
    selectedFiles: [],
  };

  files = [];
  display = 'none';

  public uploader: FileUploader = new FileUploader({
    url: this.url + '/fileupload',
    itemAlias: 'photo',
  });
  constructor(
    private residentialService: ResidentialService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.residentialService.setShowHelp.subscribe((data) => {
      this.showHelp = data.flag;
      this.userObj = {
        fullName: '',
        emailId: '',
        helpQues: '',
        type: 'help',
        selectedFiles: [],
      };
      this.filelength = this.uploader.queue.length;
      if (this.filelength > 0) {
        for (let i = 0; i < this.filelength; i++) {
          this.uploader.queue.pop();
        }
      }
      if (this.uploadedFilename.length > 0) {
        this.uploadedFilename = [];
      }
    });
    this.uploader.onAfterAddingFile = (file) => {
      this.invalidFileMsg = false;
      file.withCredentials = false;
      for (let i = 0; i < this.uploader.queue.length; i++) {
        if (
          this.uploader.queue[i].file.type === 'image/png' ||
          this.uploader.queue[i].file.type === 'image/bmp' ||
          this.uploader.queue[i].file.type === 'image/svg+xml' ||
          this.uploader.queue[i].file.type === 'image/jpeg' ||
          this.uploader.queue[i].file.type === 'application/pdf'
        ) {
          const actualFileSize = filesize(this.uploader.queue[i].file.size);
          this.uploader.queue[i].file['unitSize'] = actualFileSize;
          if (this.uploader.queue.length > 5) {
            this.errorMsg = true;
            this.uploader.queue.pop();
          }
        } else {
          this.invalidFileMsg = true;
          this.uploader.queue.pop();
        }
      }
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      this.uploadedFilename.push(response);
      if (this.uploader.queue.length === this.uploadedFilename.length) {
        this.openModal();
        this.userObj.selectedFiles = this.uploadedFilename;
        const body = new HttpParams().append(
          'supportObj',
          JSON.stringify(this.userObj)
        );
        this.http
          .post(this.url + '/saveSupport', body)
          .subscribe((res: any) => {
            const result = res;
            this.onCloseHandled();
            $('.modal-backdrop').css('display', 'none');
            $('body').css('padding-right', '0');
            $('#helpModel').modal('show');
          });
      }
    };
  }

  omit_special_char(e) {
    var k;
    document.all ? (k = e.keyCode) : (k = e.which);
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  sendHelp(event, myForm, formValid) {
    if (formValid) {
      this.uploader.uploadAll();
      this.showHelp = false;
      this.errorMsg = false;
      this.invalidFileMsg = false;
      $('#helpModel').modal('show');
    }
  }
  closeModal(form) {
    this.showHelp = false;
    this.errorMsg = false;
    this.invalidFileMsg = false;
    form.resetForm();
  }
  removeFile(removedfile) {
    removedfile.remove();
    if (this.uploader.queue.length < 5) {
      this.errorMsg = false;
    }
  }

  closeResetModal() {
    $('.modal-backdrop').css('display', 'none');
    $('body').css('padding-right', '0');
  }
  // to open the modal
  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }
}
